import './SpinnyLoader.scss';
const SpinnyLoader = () => {
	return (
		<div className="spinny-loader">
			<div className="spinny-circle"></div>
		</div>
	);
}

export default SpinnyLoader;